import { render, staticRenderFns } from "./UploadFileButton.vue?vue&type=template&id=8a9b3526"
import script from "./UploadFileButton.vue?vue&type=script&lang=js"
export * from "./UploadFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports